import { render, staticRenderFns } from "./WidgetLastFiveChecks.vue?vue&type=template&id=833945c2&"
import script from "./WidgetLastFiveChecks.vue?vue&type=script&lang=js&"
export * from "./WidgetLastFiveChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports